import _ from 'lodash'
import dispatcher from './dispatcher'
import Unique from './shared/utils/Unique'
//import Bb from 'backbone'

const store = {}

const keys = {
    game: 'game', //game status
    players: 'players', //current game
    settings: 'settings', //user settings
    playersHistory: 'playersHistory', // Players registry
    playedGamesHistory: 'playedGamesHistory', // Played Game history
}

//DEBUG PURPOSE
window.store = store

window.backup = function () {
    const keys = ['data', 'game', 'playedGamesHistory', 'players', 'playersHistory', 'settings']
    return JSON.stringify(keys.reduce((state, key) => {
        state[key] = localStorage.getItem(key)
        return state
    }, {}))
}

window.loadBackup = function (data) {
    //const data = raw
    //localStorage.clear()
    Object.keys(data).map(key => {
        localStorage.setItem(key, data[key])
        return null
    })
}


function previousStore(_storeKey) {
    const p = localStorage.getItem(_storeKey)
    return p ? JSON.parse(p) : null
}

export function serializestore() {
    const data = {}
    _.each(store, (item, key) => {
        data[key] = item.toJSON()
    })
    return data
}

function save(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
}


function onStoreChange() {
    const _store = serializestore()
    //backup(_store)
    save(keys['players'], _store.players)
    save(keys['game'], _store.game)
    save(keys['settings'], _store.settings)
    save(keys['playersHistory'], _store.playersHistory)
    save(keys['playedGamesHistory'], _store.playedGamesHistory)


    //playersBackup(_store)
}
//
// function playersBackup (_store) {
//
//
//   const previous = new Bb.Collection(previousStore(playersKey))
//   previous.isNew();
//
//
//   const players = new Bb.Collection(_store.players.map(player => {
//     return {
//       id: player.name,
//       name: player.name,
//       image: player.image
//     }
//   }))
//
//   previous.each(model=>{
//     players.add(model.toJSON())
//   })
//
//   localStorage.setItem(playersKey, JSON.stringify(players.toJSON()))
// }


export function registerStore(item, key) {
    const p = previousStore(key)
    if (p) item.reset(p)
    store[key] = item
    dispatcher.on(key + ':changed', (s) => onStoreChange())

}

export function registerEvent(evt, callback) {
    //dispatcher.on(evt, callback)
}

function resetStore(storeName) {
    const storeItem = store[storeName]
    storeItem.reset(storeItem.defaultData ? JSON.parse(JSON.stringify(storeItem.defaultData.concat())) : null)
    dispatcher.emit(storeName + ':changed')
}

export function reset() {
    Object.keys(store)
        .filter(name => name !== 'playedGamesHistory')
        .filter(name => name !== 'playersHistory')
        .filter(name => name !== 'settings')
        .map(key => resetStore(key))

    store.game.set('id', new Unique().gen())
}


export default store


// WEBPACK FOOTER //
// ./src/store.js